export default "__VITE_ASSET__30fae94a__"